import { action } from 'app/actions';

export const GET_NETWORK_PANEL_SSO_URL = 'network-panel/GET_NETWORK_PANEL_SSO_URL';
export const getNetworkPanelSsoUrl = (payload) => action(GET_NETWORK_PANEL_SSO_URL, { payload });
